/* __next_internal_client_entry_do_not_use__ localNum,useLocalNum,StrictBaseLocalMsg,backwardsCompatibleValues,DEPRECATED_backwardsCompatibleValues,strictLocalize,useStrictLocalization,withStrictLocalization auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import React, { useCallback } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { getGlobalLookup } from "../globals/lookup";
import { messageToGibberish } from "./gibberish";
import { LocalizationStore } from "./LocalizationStore";
export { localNum } from "./localNum";
export { useLocalNum } from "./useLocalNum";
export var StrictBaseLocalMsg = function(props) {
    var defaultMessage = props.defaultMessage, description = props.description, values = props.values, id = props.id;
    var localeKey = LocalizationStore.get().localeKey;
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID) {
        return /*#__PURE__*/ _jsx(FormattedMessage, {
            // eslint-disable-next-line @faire/enforce-default-message-formatjs
            defaultMessage: id,
            id: id
        });
    }
    if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
        return /*#__PURE__*/ _jsx(FormattedMessage, {
            // eslint-disable-next-line @faire/enforce-default-message-formatjs
            defaultMessage: messageToGibberish(defaultMessage),
            description: description,
            // Any default chunks should be defined using wrappers in the consuming repository
            // this is because updates to defaults need to be included in the eslintrc for that project
            values: values,
            id: id
        });
    }
    return /*#__PURE__*/ _jsx(FormattedMessage, {
        // eslint-disable-next-line @faire/enforce-default-message-formatjs
        defaultMessage: defaultMessage,
        description: description,
        // Any default chunks should be defined using wrappers in the consuming repository
        // this is because updates to defaults need to be included in the eslintrc for that project
        values: values,
        id: id
    });
};
/**
 * @deprecated
 * Replace with `DEPRECATED_backwardsCompatibleValues`.
 * This should NOT be used in new code.
 *
 * This was used to migrate from localize -> strictLocalize and LocalMsg -> StrictLocalMsg to force values objects to align and should not be used anymore
 * */ export var backwardsCompatibleValues = function(values) {
    return values;
};
/**
 * This should NOT be used in new code.
 *
 * This was used to migrate from localize -> strictLocalize and LocalMsg -> StrictLocalMsg to force values objects to align and should not be used anymore
 * */ export var DEPRECATED_backwardsCompatibleValues = function(values) {
    return values;
};
/**
 * @deprecated
 * @trackfunction
 * Access `strictLocalize` using `useStrictLocalize` (or `withStrictLocalize` for class components) instead.
 */ export var strictLocalize = function(descriptor, values, opts) {
    return LocalizationStore.get().intl.formatMessage(descriptor, values, opts);
};
export var useStrictLocalization = function() {
    var intl = useIntl();
    var _LocalizationStore_get = LocalizationStore.get(), legacyIntl = _LocalizationStore_get.intl, localeKey = _LocalizationStore_get.localeKey;
    var strictLocalize = useCallback(function(descriptor, values, opts) {
        if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.STRING_ID) {
            var _descriptor_id;
            return (_descriptor_id = descriptor.id) !== null && _descriptor_id !== void 0 ? _descriptor_id : "";
        }
        if ((localeKey === null || localeKey === void 0 ? void 0 : localeKey.language) === Language.GIBBERISH) {
            return intl.formatMessage({
                // eslint-disable-next-line @faire/enforce-default-message-formatjs
                defaultMessage: messageToGibberish(descriptor.defaultMessage),
                id: descriptor.id
            }, values, opts);
        }
        return intl.formatMessage(/**
         * react-intl uses a different formatjs version than us.
         * The descriptor types don't perfectly match, but it should work fine.
         */ descriptor, values, opts);
    }, [
        intl,
        localeKey === null || localeKey === void 0 ? void 0 : localeKey.language
    ]);
    var legacyStrictLocalize = useCallback(function(descriptor, values, opts) {
        return legacyIntl.formatMessage(descriptor, values, opts);
    }, [
        legacyIntl
    ]);
    // Return the named function for babel string extraction
    var lookup = getGlobalLookup();
    return {
        strictLocalize: lookup("isNextJS") ? strictLocalize : legacyStrictLocalize
    };
};
export var withStrictLocalization = function(Component) {
    var ComponentWithStrictLocalization = function(props) {
        var strictLocalizationProps = useStrictLocalization();
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props, strictLocalizationProps));
    };
    return ComponentWithStrictLocalization;
};
